import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import * as React from 'react';
import S from './RichText.styles';
const RichText = (props) => {
    return (React.createElement(S.Container, { variant: props.variant, flush: props.flush, "data-layout": props.layout },
        React.createElement(S.Inner, null,
            props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
            props.cta && (React.createElement(S.ButtonWrapper, { "data-cta-align": props.ctaAlign },
                React.createElement(LinkButton, { branding: "outline", href: props.cta.url, target: props.cta.target, title: props.cta.text }))))));
};
export default RichText;
